import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useSelector } from 'react-redux'

import { useSafetyTranslation } from 'cng-common/features/translations'
import { PlanReviewDialog } from 'partner360/features/planReview'

import { getCockpitFiscalYearLabel } from '../../../../lib'
import { getOfferingTitleKey } from '../../../../lib/getOfferingTitleKey'
import { selectCockpitPartnerData, selectEffectiveCockpitFYear } from '../../../../model/selectors'

interface IPlanQualityReviewDialogProps {
  partnerId: string
  programType: ProgramTypes
  onClose: () => void
}

/** The plan quality review the commitment widget's "How to improve" opens, read-only as there:
 *  how the selected offering's plan is scored and where it loses points. In the cockpit it opens
 *  in the section window the plan sections open in, so the two read as one kind of window. */
export const PlanQualityReviewDialog = ({
  partnerId,
  programType,
  onClose,
}: IPlanQualityReviewDialogProps) => {
  const fYear = useSelector(selectEffectiveCockpitFYear)
  const partnerData = useSelector(selectCockpitPartnerData)
  const t = useSafetyTranslation()

  return (
    <PlanReviewDialog
      show
      partnerId={partnerId}
      fYear={fYear}
      programType={programType}
      isGlobal={partnerData[0]?.IsGlobal === 1}
      role="partner"
      showActions={false}
      showJustifications={false}
      onClose={onClose}
      onContinue={onClose}
      onReject={onClose}
      frame="cockpit"
      description={[
        partnerData[0]?.PartnerName,
        partnerId,
        t(getOfferingTitleKey(programType)),
        getCockpitFiscalYearLabel(fYear),
      ]
        .filter(Boolean)
        .join(' · ')}
    />
  )
}

PlanQualityReviewDialog.displayName = 'PlanQualityReviewDialog'
